const Kenten = {
    elemName: '圏点',
    type: 'inline',
    doc: '圏点を打たれたテキストをタグ付けします。第1要素はテキスト本体、第2要素には「○」など圏点に利用される記号を入力します。',
    example: '《圏点：圏点を打たれた文章｜﹅》',
    minContentCount: 1,
    maxContentCount: 2,
    textTemplate: '{{$text}}',
    htmlTemplate: `
    <span {{{$htmlId}}} class="Kenten {{$classes}}"
    {{#$2}}
    style="text-emphasis: '{{$2}}'; -webkit-text-emphasis: '{{$2}}'"
    {{/$2}}         
    >
        {{{$1}}}
    </span>`,
    xmlTemplate: `<seg style="text-emphasis: filled sesame">{{{$1}}}</seg>`,
    docxTemplate: `
	<w:r>
            <w:rPr>
                <w:em w:val="dot"/>
            </w:rPr>
            <w:t>{{{$$1}}}</w:t>
    </w:r>
	`,
    latexTemplate: "\\bou{ {{{$1}}} }"
};
export default Kenten;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS2VudGVuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnZlcnRlci9pbmxpbmVfcnVsZXMvS2VudGVuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sTUFBTSxHQUFtQjtJQUMzQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLDhEQUE4RDtJQUNuRSxPQUFPLEVBQUUsa0JBQWtCO0lBQzNCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLFlBQVksRUFBRSxXQUFXO0lBQ3pCLFlBQVksRUFBRTs7Ozs7OztZQU9OO0lBQ1IsV0FBVyxFQUFFLDBEQUEwRDtJQUN2RSxZQUFZLEVBQUU7Ozs7Ozs7RUFPaEI7SUFDRSxhQUFhLEVBQUUsbUJBQW1CO0NBQ3JDLENBQUM7QUFFRixlQUFlLE1BQU0sQ0FBQyJ9